import { useAppSelector } from 'flow/hooks/useRedux';
import { CallRecordKey } from 'flow/types/EntityKeys';
import { selectOwnExtensionKey } from 'flow/selectors/ExtensionSelectors';
import { selectCallRecordVoiceMessageUniqueId } from 'flow/selectors/call-records-selectors';
import { voiceMessageUrlPath } from 'flow/utils';
import useAppContext from 'flow/hooks/useAppContext';
import Icon from 'flow/components/ui-components/Icon';
import MenuItem from 'flow/components/ui-components/MenuItem';

interface Props {
    callRecordKey: CallRecordKey;
}

const MenuItemDownloadVoicemail = ({ callRecordKey }: Props) => {
    const { i18next } = useAppContext();
    const ownExtensionKey = useAppSelector(selectOwnExtensionKey);
    const voiceMessageUniqueId = useAppSelector((state) =>
        selectCallRecordVoiceMessageUniqueId(state, callRecordKey),
    );

    if (!voiceMessageUniqueId) return null;

    return (
        <a
            href={voiceMessageUrlPath(ownExtensionKey, voiceMessageUniqueId)}
            download={true}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
        >
            <MenuItem>
                <div className="flex items-center gap-x-2">
                    <Icon iconKey="download" />
                    {i18next.t('call.voicemail.download')}
                </div>
            </MenuItem>
        </a>
    );
};

export default MenuItemDownloadVoicemail;
